import { Component, EventEmitter, Output, ViewEncapsulation } from '@angular/core';
import { PaymentService } from './payment.service'; 
import { loadStripe, Stripe, StripeCardElement, StripeElements, StripeElementsOptions } from '@stripe/stripe-js';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AddPaymentComponent } from './add-payment/add-payment.component';
import { PagedListingComponentBase, PagedRequestDto } from 'src/app/shared/components/paged-listing-component-base';
import { IPagedStripeTransactionResultRequestDto, IStripeTransactionDto } from 'src/app/models/backend/stripeTransactions';
import { UserRole } from 'src/app/models/enums';
import { RetailersService } from '../retailers/retailers.service';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-payements',
  templateUrl: './payments.component.html',
  styleUrls: ['./payments.component.scss']
})
export class PaymentsComponent extends PagedListingComponentBase<IStripeTransactionDto>{

  loader = false;
  startDate: Date = new Date();
  endDate: Date = new Date();
  activeRetailerId: any = localStorage.getItem('RetailerId');
  Role: any;
  Retailers: any;
  filterRetailer: any;
  ddlRetailer: any;
  retailerId: 0;
  boolCustom:boolean;
  showOrderDetails:boolean;


  data: any;
  totalItemsCount = 0;
  allrecords=[];
  stripeTransactions:IStripeTransactionDto[] = [];

  @Output("updated") updated = new EventEmitter<boolean>();

  private elements: StripeElements | null = null;
  private cardElement: StripeCardElement | null = null;
  isProcessing = false;
  errorMessage: string | null = null;
  amount: number | null = null; // Amount entered by the user
  private stripe: Stripe | null = null;

  request: any = {
    skipCount: 0,
    maxResultCount: 100,
    startDate:this.startDate,
    endDate: this.endDate,
    retailerId: 0,
    keywords:''
  };
  dialogConfig = new MatDialogConfig();
  

  constructor(
    private stripeService:PaymentService, 
    private dialog: MatDialog,
    private retailerService:RetailersService,
    private toastr: ToastrService
  ) {
    super();
    this.Role = localStorage.getItem('RoleType');
    this.getRetailers();
    const today = new Date().toISOString().split('T')[0]; // Get today's date
    this.startDate = new Date();
    this.startDate.setDate(this.startDate.getDate() - 1);
    this.endDate = new Date();
  }
  protected override async list(
    request: IPagedStripeTransactionResultRequestDto,
    pageNumber: number
  ) { 
    this.request.startDate = this.startDate.toISOString();
    this.request.endDate = this.endDate.toISOString();
    this.loader = true;
    console.log(this.request);
    await this.stripeService.getAllStripeTransactions(this.request).subscribe(
      {
        next:(res:any)=>{
            this.stripeTransactions = res.items;
            this.totalItemsCount = res.totalCount
            this.showPaging(res, pageNumber);
            this.loader = false;
        },
        error:(e:any)=>{
          this.loader = false
          this.toastr.error('Oops!', e.error.message);
        }
      });
  }


  override ngOnInit(): void {
    this.stripeService.initializeStripe();
    this.request={
      skipCount: 0,
      maxResultCount: 100,
      startDate:this.startDate,
      endDate: this.endDate,
      retailerId: this.retailerId
    };
    this.list(this.request,1);
 }

 isAdmin(): boolean {
  return this.Role==UserRole.Admin;
 }
 isRetailer(): boolean {
  return this.Role==UserRole.Retailer;
 }


Filter() {
  debugger
  // this.loader1=true
  this.request = {
    skipCount: 0,
    maxResultCount: 100,
    startDate: this.startDate,
    endDate: this.endDate,
    retailerId: this.activeRetailerId
  }
  if (this.retailerId > 0) {
    this.request.retailerId = this.retailerId
  }
  this.list(this.request,1);
}
onPageChanged(pageNumber: number) {

  this.request = {
    skipCount: (pageNumber - 1) * 100,
    maxResultCount: 100,
    startDate: this.startDate,
    endDate: this.endDate,
    retailerId: this.retailerId
  }
  this.list(this.request, pageNumber)
  this.getDataPage(pageNumber);
}
 isRefresh(refresh: boolean) {
  if (refresh === true) this.getDataPage(1);
}


  getRetailers() {
    var request = {
      isInvloveDeletedItems: false,
      skipCount: 0,
      maxResultCount: 100,
      Keyword: '',
    };
    this.loader = true;
    this.retailerService.GetRetailers(request).subscribe((res: any) => {
      this.Retailers = res.items;
      this.ddlRetailer = res.items;
      this.loader = false;
    });
  }


protected override delete(entity: IStripeTransactionDto): void {
  
}



  

  
filterRetailers(filterValue) {
  this.loader = true
    this.Retailers = this.ddlRetailer
    console.log(filterValue.value)
    this.retailerId = filterValue.value
    this.loader = false
  }
  onSelectChange(selectedValue) {
    selectedValue = selectedValue.value
    const today = new Date();
    const dayOfWeek = today.getDay();
    const year = today.getFullYear();
    const month = today.getMonth();
    const diff = today.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1);
    const mondayOfWeek = new Date(today.setDate(diff));
    this.boolCustom = false
    switch (selectedValue) {
      case '1': // Today
        this.startDate = new Date();
        this.endDate = new Date();
        break;
      case '2': // Yesterday
        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);
        this.startDate = yesterday;
        this.endDate = yesterday;
        break;
      case '3': // This week
        this.startDate = mondayOfWeek; // Set start date to Monday
        const endOfWeek = new Date(mondayOfWeek); // Create a new Date for the end of the week
        endOfWeek.setDate(mondayOfWeek.getDate() + 6); // Set to Sunday
        this.endDate = endOfWeek; // Set end date
        console.log(this.endDate)
        break;

      case '4': // Last Week
        const lastMonday = new Date(mondayOfWeek);
        lastMonday.setDate(lastMonday.getDate() - 7);
        const lastSunday = new Date(mondayOfWeek);
        lastSunday.setDate(lastSunday.getDate() - 1);
        this.startDate = lastMonday;
        this.endDate = lastSunday;
        break;
      case '5': // This Month
        const firstDayOfMonth = new Date(year, month, 1);
        const lastDayOfMonth = new Date(year, month + 1, 0);
        this.startDate = firstDayOfMonth;
        this.endDate = lastDayOfMonth;
        break;
      case '6': // Last Month
        const firstDayOfLastMonth = new Date(year, month - 1, 1);
        const lastDayOfLastMonth = new Date(year, month, 0);
        this.startDate = firstDayOfLastMonth;
        this.endDate = lastDayOfLastMonth;
        break;
      case '7': // Custom 
        this.boolCustom = true
        this.startDate = null;
        this.endDate = null;
        break;

      default:
        this.startDate = null;
        this.endDate = null;
        break;
    }
  }


  openPayement() {
    // Open the Angular Material dialog
    const dialogRef = this.dialog.open(AddPaymentComponent, {
      width: '500px', // Adjust width as needed
      minHeight: '400px', // Minimum height to make sure it looks good
      panelClass: 'custom-dialog-container', // Custom class for additional styling
      disableClose: true, // Prevent closing by clicking outside
      // Pass the order number to the modal
   });
   dialogRef.afterClosed().subscribe((result) => {
    if (result && result.refresh) {
      // this.isRefresh(true);
    }
  });
  
  }
  


  submitPayment() {
    if (!this.cardElement || !this.amount) return;

    this.isProcessing = true;

    // Step 1: Create Payment Intent
    this.stripeService.createPaymentIntent(this.amount * 100).subscribe(async (response) => {
      const clientSecret = response.clientSecret;

      // Step 2: Confirm Card Payment
      const result = await this.stripeService.confirmCardPayment(clientSecret, this.cardElement);

      if (result.error) {
        this.errorMessage = result.error.message;
        this.isProcessing = false;
      } else {
        alert('Payment successful!');
        this.isProcessing = false;
      }
    });
  }

//  async checkout(){
//     // Get the session ID from your backend
//    let sessionId :'';
//       this.stripeService.createCheckoutSession().then((r)=>{
//       r.subscribe(respone=>{
//         sessionId = respone.sessionId;
//         console.log(respone);
//       })
//     });

//     // Redirect to Stripe Checkout
//     const stripe = await loadStripe('pk_test_51LjhZVGuTmGUTjxZ7H6ZJZlymNc2VjHCPpdwJEnEhhTNS2wn5QmraS9srqyNXr2YqWieA5QTfhalh9BasQrZXxul00PIVPtTvt');
//     if (stripe) {
//       const { error } = await stripe.redirectToCheckout({
//         sessionId: sessionId, // Use the sessionId obtained from the backend
//       });

//       if (error) {
//         console.error('Error during Stripe Checkout:', error.message);
//       }
//     }
//   }
async checkout() {
  try {
    const { sessionId } = await this.stripeService.createCheckoutSession(50);
    await this.stripeService.redirectToCheckout(sessionId);
  } catch (error) {
    console.error('Error during checkout:', error);
  }
}
}
